import Component from "../../component";

export const PageTopperConfig = {
    signature: 'pageTopper',
    baseHtmlClass: 'page_topper',
    selector: '.page_topper',
    initedHtmlClassModifier: 'inited',
    datasetConfigKey: 'page_topper',
    identifierDatasetConfigKey: 'identifier',
};

export class PageTopper extends Component {

    static applyToAll() {
        document.querySelectorAll(PageTopperConfig.selector).forEach((element) => {
            if (!PageTopper.isElementComponentized(element, PageTopperConfig.signature)) new PageTopper(element);
        });
    }

    constructor(id_or_element, props = {}) {
        super({
            element: id_or_element,
            config: PageTopperConfig
        });

        this.setDatasetConfig(PageTopperConfig.datasetConfigKey);

        // See https://developer.mozilla.org/en-US/docs/Web/Events/scroll
        this.lastScrollPosition = window.scrollY;
        this.tick = false;  // Track whether handleScroll call is currently in process.
        window.addEventListener('scroll', this.handleScroll.bind(this));

        this.element.addEventListener('click', this.handleClick.bind(this));

        this.render();

        // Delay setting `inited` and rendering again - this avoids flashing the controls in the viewport prior to setting other initial state.
        window.setTimeout(() => {
            this.inited = true;
            this.render();
        }, 1000);

    }

    handleScroll() {
        this.lastScrollPosition = window.scrollY;
        if (!this.tick) {
            window.requestAnimationFrame(()=>{
                this.render();
                this.tick = false;
            });
            this.tick = true;
        }
    }

    handleClick(event) {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    render() {
        this.conditionallySetHtmlClassState(this.inited, 'inited');
        this.conditionallySetHtmlClassState(this.isScrolledBeyondThreshold(), 'visible');
    }

    isScrolledBeyondThreshold() {
        return (this.lastScrollPosition > window.innerHeight);
    }

}
